import type { TokenJSONObject } from '@ikegps/core-api';
import type { IkeToken } from '@ikegps/core-api';
import { action, observable, type ObservableMap, reaction, makeObservable } from 'mobx';
import { type IkeClientService, Services } from './index';

export class TokenService implements IkeClientService {
	__priority = 100;

	public tokens: ObservableMap<IkeToken, IkeToken> = observable.map<IkeToken, IkeToken>();

	constructor() {
		makeObservable(this);
	}

	init() {
		reaction(
			() => Services.Department.current,
			() => {
				// eslint-disable-next-line @typescript-eslint/no-floating-promises
				this.updateTokens();
			},
			{ name: 'TokenService:department' }
		);
	}

	@action private async updateTokens() {
		const currentDepartment = Services.Department.current;

		if (currentDepartment == null) {
			this.tokens.clear();
		} else {
			const tokens = await Services.Department.rest.tokens.fetch();
			this.setTokens(tokens);
		}
		Services.Route.tokensLoaded = true;
	}

	@action private setTokens(tokens: TokenJSONObject[]) {
		this.tokens.clear();
		for (const t of tokens) {
			this.tokens.set(t.name, t.name);
		}
	}

	has(token: IkeToken): boolean {
		return this.tokens.has(token);
	}

	hasAll(tokens: IkeToken[]): boolean {
		tokens = Array.isArray(tokens) ? tokens : [];

		for (const token of tokens) {
			if (!this.tokens.has(token)) {
				return false;
			}
		}

		return true;
	}

	getByPrefix(prefix: string): IkeToken[] {
		const tokens = Array.from(this.tokens.keys());
		return tokens.filter((token) => token.startsWith(prefix));
	}
}
